export class CmsContentDefBuilder {
  createDefaultDef(desc: string, id: string = desc.toLowerCase().replace(/ /g, '')): CmsContentDef {
    return new CmsContentDef(desc, id).withTitle().withSubTitle().withText();
  }

  createDef(desc: string, id: string = desc.toLowerCase().replace(/ /g, '')): CmsContentDef {
    return new CmsContentDef(desc, id);
  }

  createHeaderDef(desc: string, id: string = desc.toLowerCase().replace(/ /g, '')): CmsContentDef {
    return new CmsContentDef(desc, id).withHeader();
  }
}

export class CmsContentDef {
  desc: string;
  id: string;
  header: boolean;
  title: boolean;
  subtitle: boolean;
  text: boolean;
  url: boolean;
  icon = false;
  picture = false;
  minWidth: number = null;
  placeholders: string[] = [];

  constructor(desc: string, id: string) {
    this.desc = desc;
    this.id = id;
  }

  withHeader(): CmsContentDef {
    this.header = true;
    return this;
  }

  withTitle(): CmsContentDef {
    this.title = true;
    return this;
  }

  withSubTitle(): CmsContentDef {
    this.subtitle = true;
    return this;
  }

  withText(): CmsContentDef {
    this.text = true;
    return this;
  }
  withUrl(): CmsContentDef {
    this.url = true;
    return this;
  }
  withIcon(): CmsContentDef {
    this.icon = true;
    return this;
  }

  withPicture(minWidth: number): CmsContentDef {
    this.picture = true;
    this.minWidth = minWidth;
    return this;
  }

  withPlaceholders(values: string[]): void {
    this.placeholders = values;
  }
}
